export default __webpack_public_path__ + "static/media/legalEmpty.cc3450ff.svg";